import { StringHelpers } from "../../helpers/string-helpers";
import { TraceLoggingHelpers } from "../../helpers/trace-logging-helpers";
import { IChartContainer } from "../../models/base/chart-container.interface";
import { IComponent } from "../component.interface";

export class SymbolLookupComponent implements IComponent {
    public id = '';

    public symbol = '';

    private base: IChartContainer;

    constructor(base: IChartContainer) {
        this.base = base;
        this.onBodyKeydown();
    }

    private onBodyKeydown() {
        document.body.addEventListener('keydown', (event: any) => {
            if (!this.base.tiChartSeries ||
                this.base.tiChartSeries.isPopupVisible() ||
                document.activeElement?.classList.contains('chart-symbol') ||
                document.activeElement?.tagName?.toLowerCase() === 'input') {
                return;
            }

            TraceLoggingHelpers.log('Symbol lookup keydown ', event.key);
            if (StringHelpers.isAlphabetic(event.key)) {
                if (this.base.tiChartSeries.chartStyleSettings &&
                    this.base.tiChartSeries.chartStyleSettings.singleStockSupported &&
                    this.base.tiChartSeries.chartStyleSettings.singleStockEnabled) {
                    const inputElement = document.body.findFirst('.chart-symbol');
                    inputElement.focus();
                    inputElement.value = '';

                    setTimeout(() => {
                        inputElement.value = event.key.toUpperCase();
                    }, 100);
                } else {
                    this.base.chartService.requestOpenSymbolLookup(event.key.toUpperCase());
                }
            }
        });
    }
}
